import { ProgressComponents } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/_shared/ProgressComponents';
import { PaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';
import { HorizontalProgressBar } from '@/components/shared/components/HorizontalProgressBar';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { StatusTagType } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface WithNoProgressProps {
  paymentMethodDetailEntity: PaymentMethodDetailEntity;
}

export const WithNoProgress = ({ paymentMethodDetailEntity }: WithNoProgressProps) => {
  const { palette } = useCustomTheme();

  const isAvailable = paymentMethodDetailEntity.shouldCreatePaymentIntent();

  return (
    <ProgressComponents.Layout
      progressLabel="APPLICATION_PROGRESS"
      StatusTag={
        <StatusTag
          type={StatusTagType.DEFAULT}
          colorType={'main'}
          labelTextId={isAvailable ? 'AVAILABLE' : 'NOT_AVAILABLE'}
        />
      }
      ProgressBar={<HorizontalProgressBar progressValue={100} color={palette.grey[200]} style={{ margin: 0 }} />}
    >
      <ProgressComponents.NoStatus />
    </ProgressComponents.Layout>
  );
};
